import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { DivTag, ImgTag } from '../Tags/Tags';
import { BannerService } from '../../Services/authService';
import { showSuccessToast, showErrorToast } from '../../utils/toastUtils';

const SliderCrousel = () => {
  const [showCarousel, setShowCarousel] = useState(true);
  const [bannerData, setBannerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setShowCarousel(window.innerWidth > 600);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const bannerRetrieve = async () => {
    try {
      setIsLoading(true);
      const response = await BannerService();
      if (response?.status?.code === 200 || response?.status === 200) {
        const banners = response?.data || [];
        const primaryBanners = banners.filter(
          (item) => item?.banner_type?.toLowerCase() === 'primary'
        );
        setBannerData(primaryBanners);

      } else {
        showErrorToast('Unexpected response from server.');
      }

    } catch (error) {
      const status = error?.response?.status;

      if (status === 422) {
        const message = error?.response?.data?.message || 'Validation error occurred.';
        showErrorToast('Error 422: ' + message);
      } else if (status === 500) {
        showErrorToast('Error 500: Internal Server Error.');
      } else {
        showErrorToast('Error fetching banner data.', error?.message || 'Unknown error');
      }

    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    bannerRetrieve();
  }, []);

  const fallbackImages = [
    'assets/images/NGO-IDSPay-Software.png',
    'assets/images/Patho-Lab IDSPay-Software.png',
    'assets/images/IDSPay Softwares Products.png',
    'assets/images/IDSPay CRM & HR Software.png'
  ];

  return (
    <>
      {showCarousel && (
        <Carousel
          autoPlay
          infiniteLoop
          transitionTime={1000}
          interval={6000}
          showThumbs={false}
          showIndicators={true}
          className="w-[26%] invisible sm:visible"
        >
          {bannerData?.length > 0
            ? bannerData.map((banner) => (
                <DivTag key={banner.id} className="w-full overflow-hidden">
                  <ImgTag
                  loading="lazy"
                    src={banner?.image_blob?.original?.dataUri || ''}
                    alt={`banner-${banner.id}`}
                    className="w-full h-auto"
                  />
                </DivTag>
              ))
            : fallbackImages.map((src, index) => (
                <DivTag key={index} className="w-full overflow-hidden">
                  <ImgTag src={src} alt={`fallback-${index}`} className="w-full h-auto" loading="lazy" />
                </DivTag>
              ))}
        </Carousel>
      )}
    </>
  );
};

export default SliderCrousel;
